import { StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { SportBookingType } from '../types';
import SportBooking from './SportBooking';
import Coaching from './Coaching';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { book_sports_facility_white } from '../../../assets/base64';
import { IS_WEB } from '../../../constants/platform';
import { COLORS, FONTS } from '../../../constants';
import { IFacilities } from '../../../types/sports.types';
import SportApi from '../../../services/api/sports.api';
import { Loading } from '../../../components';

interface SportFacilityBookingProps {
  onPressCoaching?: () => void;
}

const SportFacilityBooking: FC<SportFacilityBookingProps> = ({
  onPressCoaching,
}) => {
  const isDesktop = useIsDesktop();
  const [facilities, setFacilities] = useState<IFacilities[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const data: SportBookingType[] = [
    {
      name: 'tennis',
      opening: 'monday - sunday, 7:00am-9:00pm',
      photo: 'https://kcc.org.hk/wp-content/uploads/2023/04/Tennis.png',
    },
    {
      name: 'aerobics',
      opening: 'monday - sunday, 7:00am-9:00pm',
      photo:
        'https://imgcms.mndrcdn.com/wp-content/uploads/2022/05/smiley-people-having-fun-zumba-class-1024x683.jpg',
    },
    {
      name: 'badminton',
      opening: 'monday - sunday, 7:00am-9:00pm',
      photo: 'https://kcc.org.hk/wp-content/uploads/2023/04/tennis.jpg',
    },
    {
      name: 'Biliards & Snooker',
      opening: 'monday - sunday, 7:00am-9:00pm',
      photo:
        'https://kcc.org.hk/wp-content/uploads/2023/04/snooker-banner-1600x757.jpg',
    },
    // {
    //   name: 'Bridge',
    //   opening: 'monday - sunday, 7:00am-9:00pm',
    //   photo:
    //     'https://kcc.org.hk/wp-content/uploads/photo-gallery/KCC_Bridge_1.jpg?bwg=1666243629',
    // },
  ];

  const getFacilities = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await SportApi.getFacilities();
      setFacilities(res.data.facilities);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getFacilities();
  }, [getFacilities]);

  const renderHeader = useMemo(() => {
    if (isDesktop()) {
      return (
        <View style={{ marginBottom: 40 }}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 20,
              paddingBottom: 20,
              borderBottomColor: STYLE_VARS.fccDarkGrey,
              borderBottomWidth: 1,
            }}
          >
            <Image
              source={
                IS_WEB
                  ? addBase64Prefix(book_sports_facility_white)
                  : require('../../../assets/my-profile.png')
              }
              style={{
                width: 24,
                height: 24,
                resizeMode: 'contain',
                marginRight: 10,
                tintColor: STYLE_VARS.primaryColor,
              }}
            />
            <Text
              style={{
                fontSize: 20,
                letterSpacing: 2,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.textColor,
                fontWeight: '500',
              }}
            >
              SPORTS FACILITY BOOKING
            </Text>
          </View>
          <Text
            style={{
              fontSize: 14,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              color: STYLE_VARS.fccDarkerGrey,
              fontWeight: '500',
            }}
          >
            PLEASE SELECT THE SPORTS FACILITY YOU WOULD LIKE TO BOOK
          </Text>
        </View>
      );
    }
    return (
      <View style={{ paddingHorizontal: 50, paddingVertical: 25 }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 20,
            justifyContent: 'center',
          }}
        >
          <Image
            source={require('../../../assets/events.png')}
            style={{
              width: 24,
              height: 24,
              resizeMode: 'contain',
              marginRight: 10,
            }}
          />
          <Text
            style={{
              fontSize: 18,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              color: STYLE_VARS.textColor,
              fontWeight: '500',
            }}
          >
            SPORTS FACILITY BOOKING
          </Text>
        </View>
        <Text
          style={{
            fontSize: 14,
            fontFamily: FONTS.IowanOldStyleBTRoman,
            color: STYLE_VARS.fccDarkerGrey,
            fontWeight: '500',
            textAlign: 'center',
          }}
        >
          PLEASE SELECT THE SPORTS FACILITY YOU WOULD LIKE TO BOOK
        </Text>
      </View>
    );
  }, [isDesktop]);

  return (
    <View>
      {renderHeader}
      {isLoading === true ? (
        <Loading />
      ) : facilities.length !== 0 ? (
        <View
          style={
            isDesktop()
              ? { flexDirection: 'row', flexWrap: 'wrap', gap: 25 }
              : { paddingHorizontal: 20 }
          }
        >
          {facilities.map((booking) => (
            <SportBooking booking={booking} key={booking.term_id} />
          ))}
        </View>
      ) : (
        <View style={styles.noDataWrapper}>
          <Text
            style={[styles.noDataText, { fontSize: isDesktop() ? 20 : 15 }]}
          >
            THERE ARE CURRENTLY NO FACILITY BOOKING
          </Text>
        </View>
      )}
      {!isDesktop() && (
        <View style={{ paddingHorizontal: 20 }}>
          <Coaching
            onPressCoaching={() => {
              if (onPressCoaching) onPressCoaching();
            }}
          />
        </View>
      )}
    </View>
  );
};

export default SportFacilityBooking;

const styles = StyleSheet.create({
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
